import React, { useState, useEffect } from "react";
import Tooltip from "../../../../components/ui/Tooltip";
import LoadingPlaceholder from "../../../../components/ui/loading/LoadingPlaceholder";
import { fetchReportPeriods } from "../../../../api/finances/reportAPI";
import { FinancialReportType } from "../../../../lib/Constants";

// Helper to format YYYY-MM to "Month Name Year" (e.g. "2026-07" -> "July 2026")
const formatPeriodLabel = (periodKey) => {
  if (!periodKey) return "";
  const [year, month] = periodKey.split("-");
  const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, 1);
  return date.toLocaleString("default", { month: "long", year: "numeric" });
};

function ReportListSelector({ content, onViewReport }) {
  const [reports, setReports] = useState([]);
  const [selectedUuid, setSelectedUuid] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [apiError, setApiError] = useState("");
  const reports_language = content.subscriber_view.reports;
  const monthly_reports_language = reports_language.monthly_reports;
  useEffect(() => {
    const loadReports = async () => {
      setIsLoading(true);
      setApiError("");

      const result = await fetchReportPeriods(
        FinancialReportType.MONTHLY_FINANCIAL_SUMMARY,
      );

      if (result.success) {
        setReports(result.data);
        if (result.data.length > 0) {
          setSelectedUuid(result.data[0].uuid);
        }
      } else {
        setApiError(result.error || "Failed to load reports.");
      }

      setIsLoading(false);
    };

    loadReports();
  }, []);

  const selectedReport =
    reports.find((r) => r.uuid === selectedUuid) || reports[0];

  if (isLoading) {
    return (
      <div className="standard-container" style={{ padding: "20px" }}>
        <LoadingPlaceholder rows={2} type="card-small" />
      </div>
    );
  }

  return (
    <div className="standard-container">
      <div className="guardian-section-header">
        <Tooltip content={monthly_reports_language.monthly_desc_tooltip}>
          <h4 className="h4-tooltip">{monthly_reports_language.title}</h4>
        </Tooltip>

        {reports.length > 0 && (
          <select
            className="form-input"
            value={selectedUuid || ""}
            onChange={(e) => setSelectedUuid(e.target.value)}
          >
            {reports.map((r) => (
              <option key={r.uuid} value={r.uuid}>
                {formatPeriodLabel(r.period_key)}
              </option>
            ))}
          </select>
        )}
      </div>

      <div className="rules-list-group">
        {apiError ? (
          <div
            style={{
              padding: "24px",
              textAlign: "center",
              color: "#EF4444",
              fontSize: "14px",
            }}
          >
            {apiError}
          </div>
        ) : selectedReport ? (
          <div className="rule-item" style={{ borderBottom: "none" }}>
            <div className="rule-item-left">
              <div className="rule-item-left-name-container">
                <span className="rule-item-name-text">
                  {monthly_reports_language.card_title_prefix} —{" "}
                  {formatPeriodLabel(selectedReport.period_key)}
                </span>
              </div>
              <span className="rule-item-description">
                {monthly_reports_language.card_period}:{" "}
                {selectedReport.period_start} to {selectedReport.period_end}
              </span>
            </div>

            <div className="rule-item-right">
              <button
                className="cta-button secondary"
                style={{ fontSize: "13px", padding: "6px 14px" }}
                onClick={() => onViewReport(selectedReport.uuid)}
              >
                {monthly_reports_language.summary_link}
              </button>
            </div>
          </div>
        ) : (
          <div
            style={{
              padding: "24px",
              textAlign: "center",
              color: "#6B7280",
              fontSize: "14px",
            }}
          >
            {monthly_reports_language.empty_report_msg}.
          </div>
        )}
      </div>
    </div>
  );
}

export default ReportListSelector;
